module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), (_vm.src) ? _c('iframe', {
    staticClass: "full-frame",
    attrs: {
      "frameborder": "0",
      "scrolling": "yes",
      "src": _vm.src
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-227b973e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inner-web-view/index.vue
// module id = 1024
// module chunks = 2